// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'crop';

export const Component = () => (
  <path d='M24.043 19.635c.335 0 .479.144.479.48 0 .334-.144.478-.479.478H5.413c-.432 0-.767-.144-1.054-.431a1.408 1.408 0 0 1-.432-1.054V5.889h1.006v13.027L18.966 4.883H.526c-.335 0-.526-.144-.526-.48 0-.334.191-.478.527-.478h18.63c.24 0 .431.048.623.144l2.97-2.97a.434.434 0 0 1 .334-.144c.336 0 .48.192.48.527 0 .144-.048.24-.144.335l-2.97 2.921c.144.24.191.48.191.67v13.22h-1.005V5.6L5.603 19.634h18.44v.001ZM19.637 21.6v2.442c0 .336.143.48.479.48.335 0 .526-.144.526-.48V21.6h-1.005ZM4.934 2.921V.48c0-.336-.144-.48-.48-.48-.334 0-.526.144-.526.479V2.92h1.006Z' />
);

export const viewBox = '0 0 25 25';
